import { render } from "./CreateCourseDialog.vue?vue&type=template&id=76c61de4&scoped=true"
import script from "./CreateCourseDialog.vue?vue&type=script&lang=js"
export * from "./CreateCourseDialog.vue?vue&type=script&lang=js"

import "./CreateCourseDialog.vue?vue&type=style&index=0&id=76c61de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c61de4"]])

export default __exports__